var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPanelScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M6.7 14.9L3.8 12l2.9-2.9-1.4-1.4-3.59 3.59a1 1 0 0 0 0 1.41l3.59 3.6 1.4-1.4zm10.6 0l2.9-2.9-2.9-2.9 1.4-1.4 3.59 3.59a1 1 0 0 1 0 1.41l-3.59 3.6-1.4-1.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M0 0H2V10H0z",
    opacity: 0.3,
    transform: "rotate(14.98 -20.089 50.236)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanelScript);
export default __webpack_public_path__ + "static/media/left-panel-script.659b40bc3f7eab91ddb591af59ef083d.svg";
export { ForwardRef as ReactComponent };